'use strict';

var jquery = require('jquery/dist/jquery');

window.jQuery = jquery;
window.$ = jquery;
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('./components/currencySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/header'));
    processInclude(require('./components/carousel'));
    processInclude(require('./components/requestCatalogue'));
    processInclude(require('./suggestions/suggestion'));
    processInclude(require('./customDropDown/customDropDown')); // TODO: check whether the custom dropdown is required globally or not
    processInclude(require('./product/base'));
    processInclude(require('./experience/components/findUsSection'));
    processInclude(require('./experience/components/ourLocations'));
    processInclude(require('./experience/components/initAutoScroll'));
    processInclude(require('./components/requestPrice'));
    processInclude(require('plugin_buynow/buyNow/pdp')); // Buy Now feature for PDP, PLP, and CLP pages
    processInclude(require('./components/formsLogic'));
    processInclude(require('./components/datePickerValidation'));
    processInclude(require('./product/addtocart'));
    processInclude(require('./cart/myDayVoucher'));
    processInclude(require('./components/einsteinCarousel'));
    processInclude(require('./components/button'));
    processInclude(require('./components/loginModalLoader'));
    processInclude(require('./guestAddress'));
    processInclude(require('./appointments/appointments'));
});

require('base/thirdParty/bootstrap');
require('./components/spinner');
require('slick-carousel');
require('./voiceSearch');
require('./thirdParty/bootstrapDatePicker');
